<template>
  <div>
    <p>Loading... <a href="https://www.instagram.com/labyhelp/">Dont work? click here</a></p>
  </div>
</template>

<script>
export default {
  name: "Discord"
}

window.open("https://www.instagram.com/labyhelp/");

</script>

<style scoped>

</style>